/**
 * Home — pinned + recent notes grid for the active user.
 */

import { createFileRoute } from "@tanstack/react-router";
import { NotesGrid } from "../components/NotesGrid";

export const Route = createFileRoute("/")({
  component: () => <NotesGrid title="Notes" filter={{ archived: false, trashed: false }} />,
});
